import React from 'react';
import { Drawer, IconButton, Portal, Box } from '@mui/material';
import FileCopyOutlinedIcon from '@mui/icons-material/FileCopyOutlined';
import { injectIntl } from 'react-intl';
import { toast } from 'react-toastify';
import { connect } from 'react-redux';
import FeedBackModal from './FeedbackModal/FeedBackModal';
import ProBadge from './SubscriptionComponents/ProBadge/ProBadge';
import ConnectWithAdviser from './connectWithAdviser';
import _ from 'lodash';
import NotificationBellButton from './NotificationBellButton/NotificationBellButton';
import NotificationCenterModal from './NotificationCenterModal/NotificationCenterModal';
import { getNotificationCenterList, markNotificationAsRead } from '../store/notificationCenter/duck';
import { markNotificationAsRead as markNotificationAsReadApi } from '../store/notificationCenter/api';
import { openHeaderMenu, closeHeaderMenu, renderHeaderButton } from '../store/headerButtonControl/duck';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';
import ListItemAvatar from '@mui/material/ListItemAvatar';
import { withRouter } from 'react-router';
import topNavTitle from './topNavTitle';
import topNavTitlePro from './topNavTitlePro';
import TodoIconButton from './TodoList/TodoIconButton/TodoIconButton';
import TodoList from './TodoList/TodoList';
import SwipeableDrawer from '@mui/material/SwipeableDrawer';
import './topNavigation.scss';
import { toggleDialog } from '../store/control/duck';
import { runGuideline } from '../store/guideline/duck';
import { updateUserDetails } from '../store/user/duck';
import IconToast from './NewToast';
import NavDrawer from './NavDrawer/NavDrawer';
import FooterNav from './FooterNav/FooterNav';
import Template from './Template/Template';
import UserMissions from './UserMissions/UserMissions';
import { getNotificationImg } from '../utils/notification-center';
import { selectedLocale } from '../store/locale/action';
import { tracking } from '../utils/tracking';
import MenuRoundedIcon from '@mui/icons-material/MenuRounded';
import { MENU_BUTTON_PATHS } from '../constants/paths';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { tryTranslate } from '../utils/locale';
import CustomTopNavigation from './CustomTopNavigation/CustomTopNavigation';
import { sanitize } from 'dompurify';
import NFCAutoGenerateButton from '../views/Advisor/Referral/partials/NFCAutoGenerateButton/NFCAutoGenerateButton';
import { hasCampaignCode, shouldEnableNFCAutoGen } from '../utils/user';
import { UserSubscription } from '../utils/user-subscription';
import { getIsChubbUser } from '../utils/user';
import MissionAndRewardEntryButton from './UserMissions/UserMissionAndReward.jsx';
import WhatsNewDialog from './WhatsNew/WhatsNewDialog';
import { fetchLatestFeatureUpdate } from '../store/featureUpdate/api';
import {
  clearWhatsNewProgress,
  getWhatsNewProgress,
  getWhatsNewUnseenCount,
  isWhatsNewUnseen,
  markWhatsNewSeen,
  nextUnopenedSlide,
  remainingCount,
  setWhatsNewProgress,
  shouldAutoOpenWhatsNew
} from './WhatsNew/notification';
import { isInternalPath } from './WhatsNew/WhatsNewDialog';
import NewClientPageButton from './NewClientPageButton/NewClientPageButton';
import { CLIENT_V1_PATH, CLIENT_V2_PATH, clientPath, isClientPath, setClientPageVersion } from '../utils/client-route';

const topNavTitleEntries = Object.entries(topNavTitle);

const UserMissionsButtonProps = { style: { position: 'absolute', left: 50, bottom: 0, zIndex: 1200, color: '#fff' } };

const NavMenuButtonStyle = {
  position: 'absolute',
  width: 'auto',
  height: '100%',
  top: '50%',
  left: 0,
  transform: 'translate(0, -50%)',
  color: '#fff',
  padding: 8
};
const NavMenuButtonIconStyle = { fontSize: '32px' };

// Mount the ToDo / Template lists only while their drawer is open. On phones and
// tablets SwipeableDrawer's `temporary` variant forces keepMounted (for
// swipe-to-open, which these drawers disable), so both lists sat mounted and
// hidden on every page and re-rendered on every page load and navigation —
// about 1.1s of render time over a /client load and ~420ms over two page
// changes in a dev build, for a drawer most sessions never open. With
// keepMounted off, content mounts on open and unmounts after the close
// transition. Neither list loads data on mount; every caller that saves a todo
// either lives inside TodoList or opens its drawer first, so error toasts still
// show (once, rather than once per mounted instance). The `persistent` variant
// above 800px has no Modal and is unaffected.
const TODO_DRAWER_MODAL_PROPS = { keepMounted: false };

export const NavMenuButton = props => {
  const { className, style, ...rest } = props;

  return (
    <IconButton
      className={`nav-menu-button${className ? ` ${className}` : ''}`}
      style={{ ...NavMenuButtonStyle, ...style }}
      {...rest}
      size="large"
    >
      <MenuRoundedIcon style={NavMenuButtonIconStyle} />
    </IconButton>
  );
};

export const getWhatsNewUserId = userDetails =>
  userDetails && ['Adviser', 'User'].includes(userDetails.userType) ? userDetails._id : undefined;

export const getWhatsNewLocale = props => props.intl?.locale || props.userDetails?.language || 'en';

const whatsNewReleases = update =>
  (Array.isArray(update?.releases) && update.releases.length ? update.releases : update ? [update] : []).slice(0, 3);

const findWhatsNewFeature = (update, featureId) => {
  for (const release of whatsNewReleases(update)) {
    const features = release.features || [];
    const index = features.findIndex(feature => feature.id === featureId);
    if (index >= 0) return { version: release.version, index, id: featureId };
  }
  return null;
};

export class TopNavigation extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      width: window.innerWidth,
      open: false,
      activeTab: 'Portfolio',
      feedBackModalOpen: false,
      connectModalOpen: false,
      showModal: false,
      todoOpen: false,
      templateOpen: false,
      whatsNewOpen: false,
      hasUnseenRelease: false,
      featureUpdate: null,
      featureUpdateStatus: 'idle',
      whatsNewProgress: null,
      whatsNewOpenedIds: [],
      whatsNewView: null
    };
    this.featureUpdateRequestId = 0;
    this.tempNotificationCenterPushed = [];
    this.notificationPushed = false;
    this.notificationCenterPushed = [];
    //this.submitFormOfFeedBack = this.submitFormOfFeedBack.bind(this);
    if (!localStorage.getItem('notificationCenterPushed')) {
      localStorage.setItem('notificationCenterPushed', JSON.stringify(this.notificationCenterPushed));
    }
  }

  componentDidMount() {
    const { userDetails, getReminderBadgeCount, getNotifications, getNotificationCenterList, location } = this.props;

    window.addEventListener('resize', this.handleResize, false);
    window.addEventListener('message', event => {
      if (event.data.type === 'SELF_BACK' && event.origin === process.env.DATA_ANALYTICS_FRONTEND_URL) {
        this.props.history.goBack();
      }
    });

    const userType = userDetails && userDetails.userType;

    if (userType === 'User' && getReminderBadgeCount !== undefined && typeof getReminderBadgeCount === 'function') {
      getReminderBadgeCount();
    }

    if (getNotifications !== undefined && typeof getNotifications === 'function') {
      getNotifications();
    }
    if (
      getNotificationCenterList !== undefined &&
      typeof getNotificationCenterList === 'function' &&
      (location.pathname === '/advisorDashboard' || location.pathname === '/dashboard')
    ) {
      getNotificationCenterList();
    }

    this.loadLatestFeatureUpdate();
  }

  componentDidUpdate(previousProps) {
    const previousUserId = getWhatsNewUserId(previousProps.userDetails);
    const currentUserId = getWhatsNewUserId(this.props.userDetails);
    const previousLocale = getWhatsNewLocale(previousProps);
    const currentLocale = getWhatsNewLocale(this.props);

    const accountChanged =
      previousUserId !== currentUserId || previousProps.userDetails?.userType !== this.props.userDetails?.userType;
    if (accountChanged || previousLocale !== currentLocale) {
      this.featureUpdateRequestId += 1;
      if (accountChanged && previousUserId === currentUserId) clearWhatsNewProgress(currentUserId);
      this.setState(
        {
          featureUpdate: null,
          featureUpdateStatus: currentUserId ? 'loading' : 'idle',
          hasUnseenRelease: false,
          whatsNewProgress: null,
          whatsNewOpenedIds: [],
          whatsNewView: null,
          ...(accountChanged ? { whatsNewOpen: false } : {})
        },
        this.loadLatestFeatureUpdate
      );
    }
  }

  componentWillUnmount() {
    this.featureUpdateRequestId += 1;
    window.removeEventListener('resize', this.handleResize, false);
  }

  handleResize = () => {
    const width = window.innerWidth;
    this.setState({ width });
  };

  parseQuery = string =>
    _.chain(string)
      .replace('?', '') // a=b454&c=dhjjh&f=g6hksdfjlksd
      .split('&') // ["a=b454","c=dhjjh","f=g6hksdfjlksd"]
      .map(_.partial(_.split, _, '=', 2)) // [["a","b454"],["c","dhjjh"],["f","g6hksdfjlksd"]]
      .fromPairs() // {"a":"b454","c":"dhjjh","f":"g6hksdfjlksd"}
      .value();

  UNSAFE_componentWillReceiveProps(props) {
    const { notifications, showToast, adviserAllModalDone, clientAllModalDone, userDetails } = props;

    if (userDetails && userDetails.userType === 'Adviser') {
      let shouldCloseTodoAndTemplate = false;
      const pathNotSame = props.location.pathname !== this.props.location.pathname;
      const queryNotSame = props.location.search !== this.props.location.search;
      const isBusinessPage = !pathNotSame && queryNotSame && props.location.pathname === '/adviser_business';
      if (isBusinessPage) {
        const newQueryParam = this.parseQuery(props.location.search);
        const oldQueryParam = this.parseQuery(this.props.location.search);
        const ignoreChange =
          newQueryParam.businessTabIndex === oldQueryParam.businessTabIndex &&
          newQueryParam.assistantCategoryIndex === oldQueryParam.assistantCategoryIndex;
        if (!ignoreChange && (this.state.todoOpen || this.state.templateOpen)) {
          shouldCloseTodoAndTemplate = true;
        }
      } else if (pathNotSame && (this.state.todoOpen || this.state.templateOpen)) {
        shouldCloseTodoAndTemplate = true;
      }
      if (shouldCloseTodoAndTemplate) {
        this.closeTodoAndTemplate();
      }
    }

    if (notifications && notifications.length > 0 && !this.notificationPushed) {
      this.notificationPushed = true;
      notifications.forEach(value => {
        if (value.type === 'info') {
          toast.info(IconToast('info', value.message), { autoClose: false, className: 'new-toast' });
        } else if (value.type === 'success') {
          toast.info(IconToast('success', value.message), { autoClose: false, className: 'new-toast' });
        } else if (value.type === 'warning') {
          toast.info(IconToast('warn', value.message), { autoClose: false, className: 'new-toast' });
        } else if (value.type === 'error') {
          toast.info(IconToast('error', value.message), { autoClose: false, className: 'new-toast' });
        } else {
          toast.info(IconToast('info', value.message), { autoClose: false, className: 'new-toast' });
        }
      });
    }
    if (showToast && showToast.length > 0) {
      if (
        (adviserAllModalDone && userDetails.userType === 'Adviser') ||
        (clientAllModalDone && userDetails.userType === 'User')
      ) {
        this.handleShowToast(showToast);
      }
    }

    const currentStepIndex = props.guidelineStepIndex;
    const steps = this.props.guidelineSteps;

    if (
      this.props.guidelineStepIndex !== currentStepIndex &&
      props.guidelineIsStarted &&
      steps[currentStepIndex] &&
      steps[currentStepIndex].requireAction
    ) {
      props.closeHeaderMenu();
    }
  }

  handleClickToastLinkTo = (notification, lang) => {
    const { markNotificationAsRead, history } = this.props;
    const regex = /\//g;
    let urlType = [];
    let hash = [];
    if (notification) {
      markNotificationAsReadApi(notification._id);
      if (notification.url && notification.url[lang] !== null && notification.url[lang] !== undefined) {
        urlType = notification.url[lang].match(regex);
      }
      if (notification.type.name === 'system') {
        if (notification.url && notification.url[lang] !== null && notification.url[lang] !== undefined) {
          if (urlType.length > 1) {
            notification.urlOpenInNewWindow
              ? window.open(notification.url[lang])
              : (window.location.href = notification.url[lang]);
          } else {
            hash = notification.url[lang].split('#');
            if (hash.length > 1) {
              history.push({
                pathname: hash[0],
                hash: hash[1]
              });
            } else {
              history.push({
                pathname: notification.url[lang]
              });
            }
          }
        } else {
          // this.props.history.push({ pathname: '/new_help_center' });
        }
      } else if (notification.type.name === 'reminder') {
        if (notification.type.tag === 'BD') {
          this.props.history.push({
            pathname: clientPath(),
            select: 'TodayAndTomorrowBirthday',
            state: { BD: notification.blastingTime }
          });
        }
        if (notification.type.tag === 'RM') {
          this.props.history.push({
            pathname: clientPath(),
            select: 'allReminder',
            state: {
              remindMeId: notification.type.extraInfo
            }
          });
        }
        if (notification.type.tag === 'PolicyReminder') {
          this.props.history.push({
            pathname: '/reminder'
          });
        } else if (notification.url && notification.url[lang] !== null && notification.url[lang] !== undefined) {
          if (urlType.length > 1) {
            notification.urlOpenInNewWindow
              ? window.open(notification.url[lang])
              : (window.location.href = notification.url[lang]);
          } else {
            hash = notification.url[lang].split('#');
            if (hash.length > 1) {
              history.push({
                pathname: hash[0],
                hash: hash[1]
              });
            } else {
              history.push({
                pathname: notification.url[lang]
              });
            }
          }
        } else {
          // this.props.history.push({ pathname: '/hot_topic' });
        }
      } else if (notification.type.name === 'promotion') {
        if (notification.url && notification.url[lang] !== null && notification.url[lang] !== undefined) {
          if (urlType.length > 1) {
            notification.urlOpenInNewWindow
              ? window.open(notification.url[lang])
              : (window.location.href = notification.url[lang]);
          } else {
            hash = notification.url[lang].split('#');
            if (hash.length > 1) {
              history.push({
                pathname: hash[0],
                hash: hash[1]
              });
            } else {
              history.push({
                pathname: notification.url[lang]
              });
            }
          }
        }
      } else if (notification.type.name === 'referral-coupon') {
        history.push({ pathname: '/subscription' });
      }
    }
  };

  handleShowToast = showToast => {
    const lang =
      this.props.userDetails.language === 'en' ? 'en' : this.props.userDetails.language === 'zh' ? 'zh' : 'zh_Hant_HK';
    const newToastIds = showToast.map((item, index) => {
      return item._id;
    });
    if (showToast && showToast.length > 5) {
      showToast.splice(5);
    }
    const notificationCenterPushed = JSON.parse(localStorage.getItem('notificationCenterPushed'));
    const toastToShow = _.difference(newToastIds, notificationCenterPushed);
    const toastToKeep = _.intersection(newToastIds, notificationCenterPushed);

    const Item = (notification, closeToast) => (
      <div>
        <ListItem
          style={{
            padding: 0,
            alignItems: 'flex-start'
          }}
          onClick={() => {
            this.handleClickToastLinkTo(notification, lang);
          }}
        >
          <ListItemAvatar
            style={{
              marginTop: '1.1rem',
              marginLeft: '1rem'
            }}
          >
            {getNotificationImg(notification.type.name, { style: { width: 40 } })}
          </ListItemAvatar>
          <ListItemText
            className="Toast-title"
            style={{
              wordBreak: 'break-word'
            }}
            primary={
              notification.type.tag === 'CONNECTION_WITH_AGENT'
                ? this.props.intl.formatMessage({ id: notification.title[lang] }, { data: notification.sender.name })
                : notification.type.tag === 'BD' ||
                  notification.type.tag === 'RM' ||
                  notification.type.tag === 'PolicyReminder'
                ? this.props.intl.formatMessage({ id: notification.title[lang] })
                : notification.title[lang]
            }
            secondary={
              <span
                style={{
                  color: 'gray',
                  fontSize: '1.4rem'
                }}
                dangerouslySetInnerHTML={
                  notification.type.tag === 'CONNECTION_WITH_AGENT'
                    ? { __html: '' }
                    : {
                        __html: sanitize(
                          notification.type.tag === 'BD' || notification.type.tag === 'RM'
                            ? this.props.intl.formatMessage(
                                { id: notification.message[lang] },
                                { data: notification.sender.name }
                              )
                            : notification.message[lang]
                        )
                      }
                }
              />
            }
          />
        </ListItem>
        <button onClick={closeToast} style={{ display: 'none' }} />
      </div>
    );
    showToast.forEach(notification => {
      if (
        toastToShow.indexOf(notification._id) > -1 &&
        this.tempNotificationCenterPushed.indexOf(notification._id) === -1
      ) {
        toast.info(Item(notification), {
          position: 'top-left',
          autoClose: false,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          className: 'notification-toast',
          onClose: () => {
            const oldNotificationCenterPushed = localStorage.getItem('notificationCenterPushed');
            if (oldNotificationCenterPushed) {
              var newNotificationCenterPushed = JSON.parse(oldNotificationCenterPushed).concat(notification._id);
            } else {
              var newNotificationCenterPushed = [notification._id];
            }
            localStorage.setItem('notificationCenterPushed', JSON.stringify(newNotificationCenterPushed));
            markNotificationAsReadApi(notification._id);
          }
        });
        this.tempNotificationCenterPushed.push(notification._id);
      }
    });
  };

  handleToggle = () => {
    if (this.props.headerButtonControl) {
      this.closeDrawer();
      this.props.closeHeaderMenu();
    } else {
      this.openDrawer();
      this.props.openHeaderMenu();
    }
  };

  closeFeedBackModal = () => {
    this.setState({ feedBackModalOpen: false });
  };

  openDrawer = () => {
    this.setState({ open: true });
    // document.body.style.overflow = 'hidden';
  };

  closeDrawer = () => {
    this.setState({ open: false });
    // document.body.style.overflow = 'unset';
  };

  closeModal = () => {
    this.setState({ showModal: false });
  };

  openTodo = () => this.setState({ todoOpen: true, templateOpen: false });
  closeTodo = () => this.setState({ todoOpen: false });

  openTemplate = () => this.setState({ templateOpen: true, todoOpen: false });
  closeTemplate = () => this.setState({ templateOpen: false });
  closeTodoAndTemplate = () => this.setState({ todoOpen: false, templateOpen: false });

  loadLatestFeatureUpdate = async () => {
    const userId = getWhatsNewUserId(this.props.userDetails);
    if (!userId) {
      this.setState({ featureUpdate: null, featureUpdateStatus: 'idle', hasUnseenRelease: false });
      return;
    }

    const requestId = ++this.featureUpdateRequestId;
    this.setState({ featureUpdate: null, featureUpdateStatus: 'loading', hasUnseenRelease: false });

    try {
      const update = await fetchLatestFeatureUpdate({
        locale: getWhatsNewLocale(this.props),
        isClient: this.props.userDetails.userType === 'User'
      });
      if (requestId !== this.featureUpdateRequestId) return;

      const progress = getWhatsNewProgress(userId);
      const cursor =
        progress && whatsNewReleases(update).some(release => release.version === progress.version) ? progress : null;
      if (progress && !cursor) clearWhatsNewProgress(userId);

      const unseen = update ? isWhatsNewUnseen(userId, update.version) : false;
      this.setState(previousState => ({
        featureUpdate: update,
        featureUpdateStatus: update ? 'ready' : 'empty',
        hasUnseenRelease: unseen,
        whatsNewProgress: cursor,
        whatsNewOpenedIds: cursor ? cursor.openedIds : [],
        whatsNewView: null,
        whatsNewOpen:
          update && shouldAutoOpenWhatsNew(unseen, cursor, update.version) ? true : previousState.whatsNewOpen
      }));
    } catch (error) {
      if (requestId !== this.featureUpdateRequestId) return;
      this.setState({ featureUpdate: null, featureUpdateStatus: 'error', hasUnseenRelease: false });
    }
  };

  clearWhatsNewSession = () => {
    const userId = getWhatsNewUserId(this.props.userDetails);
    clearWhatsNewProgress(userId);
    this.setState({ whatsNewProgress: null, whatsNewOpenedIds: [], whatsNewView: null });
  };

  rememberSeenSlide = (located, openedIds) => {
    const userId = getWhatsNewUserId(this.props.userDetails);
    const release = whatsNewReleases(this.state.featureUpdate).find(item => item.version === located.version);
    const progress = {
      version: located.version,
      openedIds,
      fromIndex: located.index,
      returnPath: (this.state.whatsNewProgress && this.state.whatsNewProgress.returnPath) || ''
    };
    setWhatsNewProgress(userId, progress);
    markWhatsNewSeen(userId, located.version);
    const hasUnseenRelease = isWhatsNewUnseen(userId, this.state.featureUpdate?.version);

    if (release && remainingCount(release.features, openedIds) === 0) {
      this.clearWhatsNewSession();
      this.setState({ hasUnseenRelease });
      return;
    }

    this.setState({
      whatsNewView: located,
      whatsNewOpenedIds: openedIds,
      whatsNewProgress: progress,
      hasUnseenRelease
    });
  };

  onFeatureViewed = featureId => {
    const located = findWhatsNewFeature(this.state.featureUpdate, featureId);
    if (!located) return;

    const sameVersion = this.state.whatsNewView?.version === located.version;
    const base = sameVersion
      ? this.state.whatsNewOpenedIds
      : this.state.whatsNewProgress?.version === located.version
      ? this.state.whatsNewProgress.openedIds
      : [];
    if (sameVersion && base.includes(featureId) && this.state.whatsNewView?.index === located.index) return;

    this.rememberSeenSlide(located, base.includes(featureId) ? base : [...base, featureId]);
  };

  whatsNewProgressRelease = () => {
    const progress = this.state.whatsNewProgress;
    if (!progress) return null;
    return whatsNewReleases(this.state.featureUpdate).find(release => release.version === progress.version) || null;
  };

  whatsNewResume = () => {
    const progress = this.state.whatsNewProgress;
    const release = this.whatsNewProgressRelease();
    if (!progress || !release) return null;

    return {
      version: progress.version,
      slide: nextUnopenedSlide(release.features, progress.openedIds, progress.fromIndex)
    };
  };

  whatsNewRemaining = () => {
    const userId = getWhatsNewUserId(this.props.userDetails);
    return getWhatsNewUnseenCount(userId, whatsNewReleases(this.state.featureUpdate));
  };

  openWhatsNew = () => {
    this.setState({ whatsNewOpen: true });
    tracking('Whats New: Opened');
  };

  closeWhatsNew = () => {
    this.setState({ whatsNewOpen: false });
  };

  finishWhatsNew = () => {
    this.closeWhatsNew();
  };

  tryWhatsNewFeature = path => {
    if (!isInternalPath(path)) return;

    const userId = getWhatsNewUserId(this.props.userDetails);
    const view = this.state.whatsNewView;
    const version = (view && view.version) || (this.state.featureUpdate && this.state.featureUpdate.version);
    const fromIndex = view ? view.index : 0;
    const openedIds =
      view && !this.state.whatsNewOpenedIds.includes(view.id)
        ? [...this.state.whatsNewOpenedIds, view.id]
        : this.state.whatsNewOpenedIds;
    const progress = { version, openedIds, fromIndex, returnPath: path };
    setWhatsNewProgress(userId, progress);
    this.setState({ whatsNewOpen: false, whatsNewProgress: progress, whatsNewOpenedIds: openedIds }, () => {
      tracking('Whats New: Try feature');
      this.props.history.push(path);
    });
  };

  openUserDrawer = () => {
    // Tracking
    tracking('User Drawer Opened');
    this.props.openHeaderMenu();
  };
  emergency = () => {
    const { history } = this.props;
    tracking('Click on SOS button on top left');
    history.push({ pathname: '/emergency_info', state: { title: { en: 'What if' } } });
  };

  render() {
    const {
      intl,
      history,
      // newReferralCount,
      // reminderBadgeCount,
      location,
      adviserSubscriptionNickname,
      hasNotifications,
      newNotificationNumber,
      headerButtonControl,
      openHeaderMenu,
      closeHeaderMenu,
      teamCampaignCodes
    } = this.props;
    const iOS = process.browser && /iPad|iPhone|iPod/.test(navigator.userAgent);
    const { showModal } = this.state;
    const isChubbUser = getIsChubbUser();
    const hasMissionAndRewardCampaignCode = !!hasCampaignCode(
      this.props.userDetails,
      teamCampaignCodes,
      'FEATURE_GAMECBB'
    );
    const shouldShowMissionAndRewardButton = hasMissionAndRewardCampaignCode;

    const user = this.props.userDetails;
    const userType = user && user.userType;
    // let productionEnv = process.env.NODE_ENV === 'production' ? true : false;
    let clickAdviser = false;
    if (userType === 'User' && user.advisorDetails && user.advisorDetails.length > 0) {
      user.advisorDetails.forEach(val => {
        if (val.connection === true) {
          clickAdviser = true;
        }
      });
    }

    // let intials = user && user.name ? user.name.charAt(0) : '';
    const isProAdviser = adviserSubscriptionNickname === 'Pro' || adviserSubscriptionNickname === 'Ultra';

    const shouldShowMenuButton = MENU_BUTTON_PATHS.find(path => new RegExp(path).test(location.pathname));
    const title =
      _.get(
        topNavTitleEntries.find(entry => location.pathname === entry[0]),
        '[1]'
      ) ||
      _.get(
        topNavTitleEntries.find(entry => location.pathname.indexOf(entry[0]) === 0),
        '[1]'
      );

    const back = () => {
      if (location.pathname.includes('/new/lab')) {
        const iframe = document.querySelector('iframe');
        iframe.contentWindow.postMessage({ type: 'IFRAME_BACK' }, process.env.DATA_ANALYTICS_FRONTEND_URL);
      } else {
        history.goBack();
      }
    };

    const _userSubscription = new UserSubscription(this.props.userSubscription);
    const shouldDisableFunctions =
      (this.props.userSubscription && _userSubscription.containVaildLinkerSubscription()) || false;

    return (
      <div id="wrapper">
        {/*Since the drawer has colored background, we can't rely on global var(--top-padding) to add padding for iOS devices*/}
        <Drawer
          open={this.props.headerButtonControl}
          onClose={closeHeaderMenu}
          slotProps={{
            paper: { style: { padding: 0 } }
          }}
        >
          <NavDrawer
            {...this.props}
            width={this.state.width}
            userSubscription={_userSubscription}
            shouldDisableFunctions={shouldDisableFunctions}
            openWhatsNew={this.openWhatsNew}
            hasUnseenRelease={this.state.hasUnseenRelease}
            whatsNewRemaining={this.whatsNewRemaining()}
          />
        </Drawer>
        <FooterNav
          {...this.props}
          width={this.state.width}
          openTodo={this.openTodo}
          closeTodo={this.closeTodo}
          todoOpen={this.state.todoOpen}
          closeTemplate={this.closeTemplate}
          openTemplate={this.openTemplate}
          templateOpen={this.state.templateOpen}
          shouldDisableFunctions={shouldDisableFunctions}
          userSubscription={_userSubscription}
        />
        <NotificationCenterModal
          open={showModal}
          onClose={() => this.closeModal()}
          history={this.props.history}
          location={this.props.location}
          // Same preference the reminder branch above obeys. Without this the
          // modal falls back to '/client', so an adviser who opted into V2
          // would be sent back to V1 by a notification but to V2 by the
          // identical top-nav reminder link.
          clientPath={clientPath()}
        />
        <WhatsNewDialog
          isClient={this.props.userDetails?.userType === 'User'}
          open={this.state.whatsNewOpen && !!getWhatsNewUserId(this.props.userDetails)}
          onClose={this.closeWhatsNew}
          onDone={this.finishWhatsNew}
          onFeatureClick={this.tryWhatsNewFeature}
          onFeatureViewed={this.onFeatureViewed}
          intl={intl}
          status={this.state.featureUpdateStatus}
          update={this.state.featureUpdate}
          resume={this.whatsNewResume()}
        />
        {(!user || !userType) && title && (
          <div>
            <div>
              <CustomTopNavigation className="top-navigation" title={title && tryTranslate(intl, title)}>
                <span className="back_arrow" onClick={back}>
                  <ArrowBackIcon />
                </span>
              </CustomTopNavigation>
            </div>
          </div>
        )}
        {user && userType === 'User' && (
          <div>
            <div>
              <CustomTopNavigation className="top-navigation" title={title && tryTranslate(intl, title)}>
                {shouldShowMenuButton ? (
                  <NavMenuButton
                    id="menu-toggle"
                    onClick={() => (headerButtonControl ? closeHeaderMenu() : this.openUserDrawer())}
                  />
                ) : (
                  <span className="back_arrow" onClick={back}>
                    <ArrowBackIcon />
                  </span>
                )}

                <IconButton
                  className="notification-bell"
                  style={
                    location.pathname === '/c-dashboard'
                      ? {
                          position: 'absolute',
                          right: this.state.width > 600 ? 33 : 23,
                          zIndex: 1100,
                          top: 0,
                          bottom: 0
                        }
                      : location.pathname === '/c-analysis' ||
                        location.pathname === '/reminder' ||
                        location.pathname === '/message' ||
                        location.pathname === '/insurer_info' ||
                        location.pathname === '/my-profile' ||
                        location.pathname === '/client-tools'
                      ? { position: 'absolute', right: 10, zIndex: 1100, top: 0, bottom: 0 }
                      : {
                          display: 'none'
                        }
                  }
                  onClick={() => {
                    this.setState({ showModal: true });
                  }}
                  size="large"
                >
                  <NotificationBellButton
                    hasNotifications={hasNotifications}
                    newNotificationNumber={newNotificationNumber}
                  />
                </IconButton>
              </CustomTopNavigation>
            </div>

            <FeedBackModal isOpen={this.state.feedBackModalOpen} onRequestClose={() => this.closeFeedBackModal()} />
          </div>
        )}
        {user && userType === 'Adviser' && (
          <div>
            <div>
              <div>
                {!shouldDisableFunctions && !isChubbUser && (
                  <UserMissions buttonProps={UserMissionsButtonProps} teamShortName={this.props.teamShortName} />
                )}

                {shouldShowMissionAndRewardButton && <MissionAndRewardEntryButton />}

                <CustomTopNavigation
                  className="top-navigation"
                  title={
                    topNavTitlePro[location.pathname]
                      ? intl.formatMessage({ id: topNavTitlePro[location.pathname] })
                      : title && tryTranslate(intl, title)
                  }
                  shouldShowProBadge={!shouldDisableFunctions && !!topNavTitlePro[location.pathname]}
                  // The PRO badge is the way into ClientV2, and only on V1's
                  // own client page — it is shown on six other routes
                  // (topNavTitlePro.json) where navigating to the client list
                  // would be nonsense, so the handler is withheld there and the
                  // badge stays the plain label it has always been.
                  proBadgeOnClick={
                    location.pathname === CLIENT_V1_PATH
                      ? () => {
                          setClientPageVersion('v2');
                          this.props.history.push(CLIENT_V2_PATH);
                        }
                      : undefined
                  }
                  proBadgeActionLabel={intl.formatMessage({ id: 'clientv2-try-new' })}
                  // The visible way into ClientV2. Unlike the PRO badge above it
                  // is shown to every adviser, whatever their plan.
                  titleAction={
                    location.pathname === CLIENT_V1_PATH && !shouldDisableFunctions ? (
                      <NewClientPageButton
                        label={intl.formatMessage({ id: 'clientv2-try-new' })}
                        shortLabel={intl.formatMessage({ id: 'clientv2-try-new-short' })}
                        onClick={() => {
                          tracking('Try New Client Page Clicked');
                          setClientPageVersion('v2');
                          this.props.history.push(CLIENT_V2_PATH);
                        }}
                      />
                    ) : undefined
                  }
                >
                  {shouldShowMenuButton ? (
                    <NavMenuButton
                      id="menu-toggle"
                      onClick={() => (headerButtonControl ? closeHeaderMenu() : openHeaderMenu())}
                    />
                  ) : (
                    <span className="back_arrow" onClick={back}>
                      <ArrowBackIcon />
                    </span>
                  )}

                  <div
                    className={`top-nav-icons${
                      location.pathname === '/advisorDashboard' ||
                      location.pathname === '/adviser_business' ||
                      location.pathname === '/home' ||
                      location.pathname === '/my-profile'
                        ? ' dashboard-icons'
                        : location.pathname === '/adviser_tools' ||
                          location.pathname === '/door-opener' ||
                          location.pathname === '/medical-card-referral' ||
                          isClientPath(location.pathname)
                        ? ''
                        : ' hide'
                    }`}
                  >
                    {!shouldDisableFunctions && !isClientPath(location.pathname) && (
                      <IconButton
                        className={'notification-bell'}
                        onClick={() => {
                          this.setState({ showModal: true });
                        }}
                        size="large"
                      >
                        <NotificationBellButton
                          hasNotifications={hasNotifications}
                          newNotificationNumber={newNotificationNumber}
                        />
                      </IconButton>
                    )}
                    {!shouldDisableFunctions && (
                      <div
                        className={`todo-btn${
                          location.pathname === '/advisorDashboard' ||
                          location.pathname === '/adviser_business' ||
                          location.pathname === '/home' ||
                          location.pathname === '/my-profile'
                            ? ' extra-margin'
                            : ' normal-margin'
                        }`}
                      >
                        <TodoIconButton
                          activeTodo={this.props.activeTodo}
                          handleClick={() => {
                            // Tracking
                            tracking('Todo List Opened');
                            this.openTodo();
                          }}
                        />
                      </div>
                    )}
                  </div>
                  <div
                    className={`top-nav-icons${
                      this.state.width <= 600 &&
                      (this.props.location.pathname === '/apendix' ||
                        this.props.location.pathname === '/detail' ||
                        this.props.location.pathname === '/plan' ||
                        this.props.location.pathname === '/payment')
                        ? ''
                        : ' hide'
                    }`}
                  >
                    <IconButton edge="start" aria-label="copy" onClick={this.openTemplate} size="large">
                      <FileCopyOutlinedIcon className="top-copy-btn" />
                    </IconButton>
                  </div>

                  {location.pathname === '/referral_records' &&
                    shouldEnableNFCAutoGen({ user: user, teamCampaignCodes }) && (
                      <NFCAutoGenerateButton style={{ color: '#fff', position: 'absolute', right: 0 }} />
                    )}
                </CustomTopNavigation>
              </div>
            </div>

            <div className="">
              <SwipeableDrawer
                anchor="right"
                variant={this.state.width > 800 ? 'persistent' : 'temporary'}
                onClose={this.closeTodo}
                onOpen={this.openTodo}
                open={this.state.todoOpen}
                disableBackdropTransition={!iOS}
                disableDiscovery={iOS}
                disableSwipeToOpen={true}
                ModalProps={TODO_DRAWER_MODAL_PROPS}
                className="client-page-filter-SwipeableDrawer"
                slotProps={{
                  paper: { elevation: 10, style: { zIndex: 1300 } }
                }}
              >
                <TodoList close={this.closeTodo} openTemplate={this.openTemplate} />
              </SwipeableDrawer>
            </div>
            <div className="">
              <SwipeableDrawer
                anchor="right"
                variant={this.state.width > 800 ? 'persistent' : 'temporary'}
                onClose={this.closeTemplate}
                onOpen={this.openTemplate}
                open={this.state.templateOpen}
                disableBackdropTransition={!iOS}
                disableDiscovery={iOS}
                disableSwipeToOpen={true}
                ModalProps={TODO_DRAWER_MODAL_PROPS}
                className="client-page-filter-SwipeableDrawer"
                slotProps={{
                  paper: { elevation: 10, style: { zIndex: 1300 } }
                }}
              >
                <Template close={this.closeTemplate} />
              </SwipeableDrawer>
            </div>
          </div>
        )}
        <ConnectWithAdviser
          open={this.state.connectModalOpen}
          onClose={() => {
            this.setState({ connectModalOpen: false });
          }}
          intl={intl}
          clickAdviser={clickAdviser}
        />
      </div>
    );
  }
}

const container = connect(
  // Map state to props
  state => ({
    userDetails: state.user.userDetails,
    teamShortName: state.team.teamShortName,
    teamLogoUrl: state.team.teamLogoUrl,
    adviserSubscriptionNickname: state.userSubscription.adviserSubscriptionNickname,
    hasNotifications: state.notificationCenter.hasNotifications,
    newNotificationNumber: state.notificationCenter.newNotificationNumber,
    notificationCenterData: state.notificationCenter.notificationCenterData,
    showToast: state.notificationCenter.showToast,
    headerButtonControl: state.headerButtonControl.headerButtonControl,
    showMenuButton: state.headerButtonControl.showMenuButton,
    getNotification: state.notificationCenter.getNotification,
    adviserAllModalDone: state.notificationCenter.adviserAllModalDone,
    clientAllModalDone: state.notificationCenter.clientAllModalDone,
    activeTodo: _.isEmpty(state.user.adviserTodo)
      ? []
      : state.user.adviserTodo.activeAdviserTodo.concat(state.user.adviserTodo.importantAdviserTodo),
    guidelineIsStarted: state.guideline.start,
    guidelineIsRunning: state.guideline.run,
    guidelineSteps: state.guideline.steps,
    guidelineStepIndex: state.guideline.stepIndex,
    reminderBadgeCount: state.reminder.reminderBadgeCount,
    teamCampaignCodes: state.functions.campaignCodes,
    userSubscription: state.userSubscription.userSubscription
  }),
  // Map actions to props
  {
    getNotificationCenterList,
    markNotificationAsRead,
    openHeaderMenu,
    closeHeaderMenu,
    renderHeaderButton,
    toggleDialog,
    runGuideline,
    updateUserDetails,
    selectedLocale
  },
  // mergeProps
  null,
  // options
  {}
)(TopNavigation);

export const TopNavigationPortal = props => (
  <Portal container={() => document.querySelector('.top-navigation > div')} {...props} />
);

export default withRouter(injectIntl(container));
